import {maxWidth, NARROW_LAYOUT_MAX} from './breakpoints';
import {fontSize, lineHeight} from './tokens';

/**
 * Shared size for every section's `<h2>`.
 *
 * 30px on phones, 48px from `sm` up, and a step down to 36px on laptop-class screens
 * (≤1499px wide): at 48px these headings wrap to three lines there and eat the vertical
 * room the sections below them need, and at 35px they did the same on a phone. Apply as
 * `sx` — a `fontSize` prop on the Typography would win over this and drop the
 * narrow-screen rule.
 */
export const sectionHeadingSx = {
    fontSize: {xs: fontSize[30], sm: 48},
    [maxWidth(NARROW_LAYOUT_MAX)]: {fontSize: fontSize[36], lineHeight: lineHeight[48]}
} as const;
